

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';

function CreateChatbot() {
  const [chatbotName, setChatbotName] = useState('');
  const [userName, setUserName] = useState('');
  const [content, setContent] = useState('');
  const [chatbotTitle, setChatbotTitle] = useState('');
  const [file, setFile] = useState(null);
  const [isFileSelected, setIsFileSelected] = useState(false);

  const navigate = useNavigate();


  // Handle file upload (PDF or DOC)
  const handleFileUpload = (e) => {
    setFile(e.target.files[0]);
    setIsFileSelected(true);
    setContent(''); // Clear content if file is selected
  };

  // Handle content text input (if not using a file)
  const handleContentChange = (e) => {
    setContent(e.target.value);
    setIsFileSelected(false); // Unselect file if content is being typed
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    // formData.append('chatbot_title', chatbotTitle);
    formData.append('chatbot_name', chatbotName);
    formData.append('user_name', userName);
    // Capture email from localStorage without setting it in the component state
    const accessLevel = localStorage.getItem('email');  // Retrieve the email-like value
    if (accessLevel) {
      formData.append('email', accessLevel); // Append access_level as email to formData
    }


    // Check if file is uploaded or if content is manually provided
    if (isFileSelected && file) {
      formData.append('file', file);  // Send file (PDF or DOC) to backend
    } else {
      formData.append('content', content);  // Send manual content to backend
    }


    try {
      const response = await fetch(`${API_BASE_URL}/create-chatbot`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        alert('Chatbot created successfully!');
        navigate('/');
      } else {
        alert('Failed to create chatbot.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 text-slate-100 flex items-center justify-center px-4">
      <div className="w-full max-w-xl bg-slate-950 border border-slate-800 rounded-xl p-6 shadow-xl">

        <h1 className="text-xl font-semibold mb-1">Create New Clone</h1>
        <p className="text-sm text-slate-400 mb-6">
          Upload a document or paste content to train your chatbot
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">

          {/* Title */}
          {/* <div>
            <label className="block text-xs text-slate-400 mb-1">Clone Title</label>
            <input
              type="text"
              value={chatbotTitle}
              onChange={(e) => setChatbotTitle(e.target.value)}
              placeholder="Chai Pe Charcha"
              className="w-full rounded-lg bg-slate-800 border border-slate-700
                       px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-500
                       outline-none"
              required
            />
          </div> */}

          {/* Name */}
          <div>
            <label className="block text-xs text-slate-400 mb-1">Chatbot Name</label>
            <input
              type="text"
              value={chatbotName}
              onChange={(e) => setChatbotName(e.target.value)}
              placeholder="Shailendra ka Dimag"
              className="w-full rounded-lg bg-slate-800 border border-slate-700
                       px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-500 
                       outline-none"
              required
            />
          </div>

          {/* User */}
          <div>
            <label className="block text-xs text-slate-400 mb-1">User Name</label>
            <input
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Partner Saab"
              className="w-full rounded-lg bg-slate-800 border border-slate-700
                       px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-500
                       outline-none"
              required
            />
          </div>

          {/* File */}
          <div>
            <label className="block text-xs text-slate-400 mb-1">
              Upload PDF / DOC (optional)
            </label>
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={handleFileUpload}
              className="w-full text-sm text-slate-300"
            />
            <p className="text-[11px] text-slate-500 mt-1">
              Upload file OR paste text below
            </p>
          </div>

          {/* Text */}
          <div>
            <label className="block text-xs text-slate-400 mb-1">
              Paste Text Content
            </label>
            <textarea
              value={content}
              onChange={handleContentChange}
              disabled={isFileSelected}
              rows={5}
              className={`w-full rounded-lg bg-slate-800 border border-slate-700
                        px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-500
                        outline-none ${isFileSelected && "opacity-50"}`}
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="w-full mt-4 rounded-lg bg-emerald-500 text-slate-900
                     py-2 text-sm font-semibold hover:bg-emerald-400 transition"
          >
            Create Clone
          </button>

        </form>
      </div>
    </div>
  );

}

export default CreateChatbot;
